<template>
  <CustomLineChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    :card-options="cardOptions"
    @reload="getData"
  />
</template>

<script>
import CustomLineChart from '@/components/cards/models/CustomLineChart';
import { mapActions, mapGetters } from 'vuex';
import colors from '@/utils/colors';
import EventBus from '@/utils/event-bus';
import cardsModel from '@/mixins/cards-model';
import { sortSeries } from '@/utils/sorting';
import { stringDateToTimestamp } from '@/utils/formatter';

const {
  neutralColor,
  linkedinColor,
} = colors;

export default {
  name: 'CallsIncomingAttended',
  components: {
    CustomLineChart,
  },
  mixins: [
    cardsModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
      filteredValues: [],
      maxValue: 0,
      cardOptions: {
        chart: {
          type: 'spline',
        },
        plotOptions: {
          column: {
            borderWidth: 0,
          },
        },
        xAxis: {
          type: 'datetime',
          labels: {
            format: '{value: %d/%m}',
          },
        },
        yAxis: [{
          title: {
            text: '',
          },
          max: this.maxValue,
        },
        {
          title: {
            text: '',
          },
          opposite: true,
          max: this.maxValue,
          labels: {
            enabled: false,
          },
        },
        ],
        tooltip: {
          xDateFormat: '%d/%m/%Y',
        },
        legend: {
          enabled: true,
          align: 'left',
          verticalAlign: 'bottom',
        },
      },
    };
  },
  computed: {
    ...mapGetters('dashboard', [
      'activeDashboardFilters',
      'activeGlobalFilter',
    ]),
    series() {
      if (!this.rawSeries || !this.rawSeries.length) {
        return [];
      }

      let series = this.rawSeries;

      if (this.filteredValues.length) {
        series = series.filter(point => {
          return this.filteredValues.includes(point.name);
        }) || [];
      }

      const organizedSeries = series.map(serie => {
        return {
          name: serie.name,
          data: serie.data.map((val) => val || 0),
          yAxis: serie.yAxis || 0,
          type: serie.type || 'spline',
          color: serie.color || neutralColor,
          zIndex: serie.zIndex,
          marker: {
            enabled: false,
          },
        };
      });

      const sortedSeries = sortSeries(organizedSeries);
      return sortedSeries;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getTotalCallsService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getTotalCallsService({
        itemId: this.itemId,
        servicePath: 'getIncomingAttended',
        serviceParams: {
          operatorsIds: this.card.props.filter?.sac_replier?.value.toString(),
        },
      })
        .then((response) => {
          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }

          this.requestStatus = 'success';

          if (!response) {
            return;
          }

          const series = [
            {
              yAxis: 1,
              name: 'Atendidos',
              data: response.map(({ attendedCalls, date }) => ([stringDateToTimestamp(date), attendedCalls])),
              color: linkedinColor,
              zIndex: 1,
              type: 'column',
            },
            {
              yAxis: 0,
              name: 'Recebidos',
              data: response.map(({ totalCallsIncoming, date }) => ([stringDateToTimestamp(date), totalCallsIncoming])),
              zIndex: 1,
            },
          ];

          this.maxValue = Math.max(...response.map(({ totalCallsIncoming }) => totalCallsIncoming));

          this.cardOptions.yAxis[0].max = this.maxValue;
          this.cardOptions.yAxis[1].max = this.maxValue;

          this.rawSeries = series;
        })
        .catch((error) => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>
